import { memo } from 'react';
import { themeCssVar as theme } from '@tinderapp/ui-react';

import SvgIcon from './lib/SvgIcon';

type Props = React.ComponentProps<typeof SvgIcon> & {
  fill?: string;
  theme?: 'plus' | 'gold' | 'platinum';
};

const TinderIcon = (props: Props) => {
  const { fill: customFill, theme: brandTheme = 'plus', ...restProps } = props;

  const fill =
    customFill ??
    {
      plus: theme.gradientFill.backgroundBrandGradient,
      gold: theme.gradientFill.backgroundGold,
      platinum: theme.gradientFill.backgroundPlatinum,
    }[brandTheme];

  return (
    <SvgIcon {...restProps}>
      <path
        d="M8.21 10.08c-.02 0-.04 0-.06-.02-.67-.9-.84-2.44-.89-3.03 0-.11-.13-.18-.23-.12C4.93 8.08 3 10.86 3 13.54 3 18.14 6.2 22 11.7 22c5.15 0 8.7-3.98 8.7-8.46 0-5.87-4.2-9.77-7.93-11.53a.13.13 0 0 0-.19.14c.48 3.16-.18 6.6-4.07 7.93z"
        fill={fill}
        fillRule="nonzero"
      />
    </SvgIcon>
  );
};

TinderIcon.normalized = true;

export default memo(TinderIcon);
